const WEEK_PREFIX = 'WK';

const getFootballSlateLabel = (name?: string) => {
  if (!name) return WEEK_PREFIX;

  const regex = /Week (\d+)/;
  const match = name.match(regex);

  if (match && match[1]) {
    const extractedNumber = parseInt(match[1], 10);
    return `${WEEK_PREFIX} ${extractedNumber}`;
  }

  return name;
};

export default getFootballSlateLabel;
